export default class BitmapText extends PIXI.extras.BitmapText {

    // These currency codes have full stops or other common bitmap font characters in, which would mean that
    // these codes show up incorrectly (due to half characters being missing).
    // These should be removed entirely if found.
    //                                             ISK, PEN, CHF, CHF, LRD, RUB, LBP, OMR, QAR, SYP
    public static mixedCurrencyCodes: string[] = ["kr.", "S/. ", "SFr.", "Fr.", "L$", "р.", "ل.ل", "ر.ق", "ر.ع." , "£S"];

    public autoShrink: boolean = true;

    public positionWidth: number;
    public positionHeight: number;

    private scaling: boolean;

    public setVisible(visible: boolean): void {
        this.visible = visible;
    }

    public setText(text: string): void {
        this.text = text;
    }

    public setAutoResize(autoresize: boolean): void {
        this.autoShrink = autoresize;
    }

    public move(x: number, y: number, align: string) {
        if (this.anchor instanceof PIXI.Point) {
            this.anchor = new PIXI.Point(0, 0) as any;
        }

        this.x = x;
        this.y = y;

        let anchor;

        // Alignment
        if (align === "center") {
            anchor = new PIXI.Point(0.5, 0.5);
        } else if (align === "right") {
            anchor = new PIXI.Point(1, 0.5);
        } else {
            anchor = new PIXI.Point(0, 0.5);
        }

        this.anchor = anchor as any;

        this.x += this.positionWidth * anchor.x;
        this.y += this.positionHeight * anchor.y;
    }

    public resize(width: number, height: number, fontSize: number) {
        this.positionWidth = width;
        this.positionHeight = height;

        const oldFont = this.font as any;
        this.font = { size: fontSize, name: oldFont.name };
    }

    protected updateText() {
        if (this.scaling) {
            return;
        }

        this.resetScale();

        this.removeMixedCurrencies();

        super.updateText();

        if (this.autoShrink) {
            this.scaleToFit();
        }
    }

    private resetScale() {
        this.scale.x = this.scale.y = 1;
    }

    private scaleToFit() {
        this.scaling = true;
        if (this.textWidth > this.positionWidth) {
            this.scale.x = this.scale.y = this.positionWidth / this.textWidth;
        }
        this.scaling = false;
    }

    private removeMixedCurrencies() {
        const font = this.font as { name?: string; size?: number; };
        const fontName = font.name;

        const data = PIXI.extras.BitmapText.fonts[fontName];

        let hasAllCharacters: boolean = true;

        let charCode;
        let charData;
        for (let i: number = 0; i < this.text.length; i++) {
            charCode = this.text.charCodeAt(i);
            charData = data.chars[charCode];

            if (!charData) {
                hasAllCharacters = false;
            }
        }

        if (!hasAllCharacters) {
            BitmapText.mixedCurrencyCodes.forEach((currencyCode: string) => {
                if (this.text.indexOf(currencyCode) > -1) {
                    this.text = this.text.replace(currencyCode, "");
                }
            });
        }
    }
}
